import { render, staticRenderFns } from "./SendTemplates.vue?vue&type=template&id=13ca5701&scoped=true&"
import script from "./SendTemplates.vue?vue&type=script&lang=js&"
export * from "./SendTemplates.vue?vue&type=script&lang=js&"
import style0 from "./SendTemplates.vue?vue&type=style&index=0&id=13ca5701&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca5701",
  null
  
)

export default component.exports